//*************************************************************************************
//* WaMS Component Framework - app.js
//* Version 1.03f
//* Author: Damian Koch
//* Component framework essentials, plus utilities.
//* Requires jQuery, foundation
//* 10/3/17  DBK: Added error messaging support to delete functionality, return JSON with
//*            errorMessage set as the message to use.
//* 10/5/17  DBK: Added isDebugMode flag.  Console messages only show when isDebugMode = 1
//* 10/10/17 BWH: Added subtype to allow for additional variables to be passed on creation of component
//* 10/24/17 DBK: Added JSON support to save action
//* 10/30/17 DBK: Added tooltip support
//* 11/01/17 DBK: Fix bindEditMode race condition for bindCheckboxLists
//* 11/09/17 DBK: Prevent save on [enter] keypress
//* 11/21/17 DBK: Allow HTML tooltips
//* 11/28/17 DBK: Added rich text editor support (jqte called on [data-role=richtext]
//* 12/14/17 DBK: Added to robustness of action bound debug message
//* 12/18/17 DBK: Allow page component updateId actions to work with non-int Ids
//* 2/15/18  BWH: Hooked in foundation date picker
//* 4/2/18   WMK: Added back to top functionality
//* 4/16/18  WQP: Updated select/deselect many logic to only select visible (filtered) results
//* 5/14/18  DBK: Added robust filtering and paging to component lists
//* 5/14/18  DBK: Added isPrintableCharacter helper method
//* 5/25/18  Hanson: Removed the cancel action if someone hits escape in text area text box
//* 09/21/2018 BWH: Moved validation token definition from page to the component
//* 12/18/18   BWH: Updates to component filter for timeout and update to printable charachters
//*************************************************************************************

//$(document).foundation();

var app = (function () {
    var myApp = {
        Page: function (applicationPath) {
            this.appPath = applicationPath || '';
            this.id = 0;
            this.loads = 0;

            this.isDebugMode = 1;

            this.components = {};
            this.componentActions = {};
            this.currentComponent = {};
            this.allComponents = {};
            this.storage = {};
            
            this.selectors = {
                components: ':not([data-role~="component-template"]) [data-role~="component"]',
                componentActions: '[data-role~="component-action"]',
                datepicker: '[data-role~="datepicker"]',
                modals: {
                    confirmRemove: '#removeConfirmModal',
                    confirmRemoveOkButton: '#removeConfirmModal--ok',
                    descriptiveError: '#descriptiveErrorModal',
                    descriptiveErrorMessage: '[data-role~="descriptiveErrorMessage"]',
                    loadError: '#loadErrorModal',
                    removeConfirm: '#removeConfirmModal',
                    saveError: '#saveErrorModal'
                },
                searchBar: '[name=searchForm]'
            };

            this.initCheckboxLists();
            this.initModals();
            this.initTooltips();
            this.initComponents();
            this.initBackToTopButton();
        }
    };

    myApp.Page.prototype.startLoad = function () { if (++this.loads === 1 && this.selectors.loading) this.selectors.loading.show(); };
    myApp.Page.prototype.endLoad = function () { if (--this.loads === 0 && this.selectors.loading) this.selectors.loading.hide(); };

    myApp.Page.prototype.init = function () { this.log('init called on page, but not implemented'); };
    myApp.Page.prototype.initCheckboxLists = function () { this.bindCheckboxLists(this.el); };
    myApp.Page.prototype.initTooltips = function () { $(document).foundation(); };

    myApp.Page.prototype.initComponents = function () {
        //for each component, set up the component
        var page = this;
        //exclude child components
        $(this.selectors.components).not(this.selectors.components + ' ' + this.selectors.components).each(function () { page.initComponent(this, page); });
        $(this.selectors.componentActions).not(this.selectors.components + ' ' + this.selectors.componentActions).each(function () { page.initPageAction(this, page); });
    };
    myApp.Page.prototype.initComponent = function (e, pc, subtype) {
        var type = $(e).closest('[data-component-type]').data('component-type');
        var group = type + ($(e).closest('[data-component-group]').data('component-group') || "");
        var parent = pc || this;

        if (parent.components[group] === undefined) {
            parent.components[group] = [];
            parent.components[group + '-noResults'] = $('[data-component-role="noResults"][data-component-type="' + group + '"]', parent.el);
        }

        var obj = new app.component.Component(e, pc, this, subtype);
        obj.init();
        parent.components[group].push(obj);

        this.findAllComponents();

        $(document).trigger("component-init-complete", obj);
        $(document).trigger("component-init-complete-" + this.type, this);
    };
    myApp.Page.prototype.initPageAction = function (e, pc) {
        var parent = pc || this;
        var obj = new app.component.PageAction(e, pc, this);

        if (parent.componentActions[obj.type] === undefined) {
            parent.componentActions[obj.type] = [];
        }

        $(e).on(obj.event, $.proxy(obj.triggerAction, obj));

        //watch for enter keypress on component action text boxes. this will prevent submits
        $(e).on("keypress keydown",
            function(e) {
                if (e.keyCode === 13 && $(event.target).is("input[type='text']")) {
                    e.preventDefault();
                    return false;
                }
            });
        parent.componentActions[obj.type].push(obj);
        $(document).trigger("component-action-init-complete", obj);
        this.log(obj.action + ' ' + obj.type + ' ' + obj.target + '(' + obj.event + ')' + obj.el.attr('name') + ' action bound.');
    };
    myApp.Page.prototype.initModals = function () {
        this.handleRemoveOkButton = function () {
            if (this.currentComponent) {
                if (typeof this.currentComponent.confirmRemove === 'function') this.currentComponent.confirmRemove();
            }
        };
        $(this.selectors.modals.confirmRemoveOkButton).on('click', $.proxy(this.handleRemoveOkButton, this));
    };
    myApp.Page.prototype.initBackToTopButton = function () {
        $(window).scroll(function () {
            if ($(".back-to-top").css('position') === 'fixed') {
                var mainTop = $('main').offset().top;
                if ($(this).scrollTop() > mainTop) {
                    $('.back-to-top').fadeIn();
                } else {
                    $('.back-to-top').fadeOut();
                }
            }
        });
        $(document).on('click', '.back-to-top', function () {
            $(this).fadeOut();
        });
    };
    myApp.Page.prototype.initToasts = function () {
        window.toastr.options = {
            "closeButton": true,
            "debug": false,
            "newestOnTop": false,
            "progressBar": true,
            "positionClass": 'toast-top-right',
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": '300',
            "hideDuration": '1000',
            "timeOut": '5000',
            "extendedTimeOut": '1000',
            "showEasing": 'swing',
            "hideEasing": 'linear',
            "showMethod": 'fadeIn',
            "hideMethod": 'fadeOut'
        };
    };

    myApp.Page.prototype.bindCheckboxLists = function (el) {
        $('[type="checkbox"][data-role~="selectall"]', el).each(function () {
            $('[type="checkbox"][name="' + $(this).attr('name') + '"]').change(function () {
                if ($(this).attr('data-role') === 'selectall') {
                    $('[type="checkbox"][name="' + $(this).attr('name') + '"]:visible').prop('checked', this.checked);

                } else {
                    var selAll = $('[type="checkbox"][data-role~="selectall"][name="' + $(this).attr('name') + '"]:visible');

                    //check for all selected, or not all selected
                    if (selAll.is(':checked')) {
                        if (!this.checked) {
                            selAll.prop('checked', this.checked);
                        }
                    } else {
                        if ($('[type="checkbox"][name="' + $(this).attr('name') + '"]:not(:checked)').length === 1) {
                            selAll.prop('checked', this.checked);
                        }
                    }
                }
            });
        });
    };

    myApp.Page.prototype.getElementValue = function (el, valueType) {
        switch (valueType) {
            case 'html':
                return el.html();
            case 'seltext':
                return $(':selected', el).text();
            case 'val':
                return el.val();
            default:
                return el.text();
        }
    };
    myApp.Page.prototype.getGuid = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0;
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    };
    myApp.Page.prototype.showDescriptiveError = function (message) {
        $(app.page.selectors.modals.descriptiveErrorMessage, app.page.selectors.modals.descriptiveError).html(message);
        $(app.page.selectors.modals.descriptiveError).foundation('open');
    };
    myApp.Page.prototype.handleJsonMessage = function (s) {
        if (s.errorMessage !== undefined) {
            app.page.showDescriptiveError(s.errorMessage);
            return true;
        }
        return false;
    };
    myApp.Page.prototype.handleAjaxError = function (xmlHttpRequest, textStatus, error) {
        if (xmlHttpRequest.status === 401 || xmlHttpRequest.status === 302) {
            window.location.replace(app.page.appPath + '/Account/Login?ReturnUrl=' + encodeURIComponent(window.location.pathname));
        } else if (textStatus !== 'abort' && xmlHttpRequest.readyState !== 0) {
            app.page.log(error);
            if (xmlHttpRequest.responseText !== '') {
                app.page.showDescriptiveError(xmlHttpRequest.responseText);
            } else {
                $(app.page.selectors.modals.loadError).foundation('open');
            }
        }
    };
    myApp.Page.prototype.mergeSort = function (arr, target) {
        if (arr.length < 2) return arr;

        var middle = parseInt(arr.length / 2);
        var left = arr.slice(0, middle);
        var right = arr.slice(middle, arr.length);

        return this.merge(this.mergeSort(left, target), this.mergeSort(right, target), target);
    };
    myApp.Page.prototype.merge = function (left, right, target) {
        var result = [];

        while (left.length && right.length) {
            //if (left[0] <= right[0]) {
            if ($('[data-label="' + target + '"]', left[0]).text() <=
                $('[data-label="' + target + '"]', right[0]).text()) {
                result.push(left.shift());
            } else {
                result.push(right.shift());
            }
        }

        this.log("left: " + left.length + " right: " + right.length);

        while (left.length) result.push(left.shift());
        while (right.length) result.push(right.shift());

        return result;
    };
    myApp.Page.prototype.log = function (s) {
        if (this.isDebugMode) console.log(s);
    };
    myApp.Page.prototype.isJsonString = function (s) {
        try {
            JSON.parse(s);
        } catch (e) {
            return false;
        }
        return true;
    };
    myApp.Page.prototype.isPrintableCharacter = function (s) {
        //REMOVED s===13 (enter) from printable characters BWH 
        return s === 8 || (s > 47 && s < 58) || (s > 64 && s < 91) || (s > 95 && s < 112) || (s > 185 && s < 193) || (s > 218 && s < 223);
    };

    myApp.Page.prototype.findAllComponents = function () {
        this.allComponents = {};
        this.findComponents(this.components);
    };
    myApp.Page.prototype.findComponents = function (components) {
        for (var group in components) {
            if (this.allComponents[group] === undefined) {
                this.allComponents[group] = [];
            };
            $.merge(this.allComponents[group], components[group]);
            for (var key in components[group]) {
                this.findComponents(components[group][key].components);
            }
        }
    };

    return myApp;
}());

app.component = (function () {
    var myComponent = {
        Component: function (e, pc, page, subtype) {
            this.el = $(e);
            this.parentController = pc || {};
            this.page = page || app.page;
            this.subtype = subtype || this.el.closest('[data-component-subtype]').data('component-subtype');
            this.id = this.el.data('component-id') || 0;
            this.role = this.el.closest('[data-component-role]').data('component-role');
            this.type = this.el.closest('[data-component-type]').data('component-type');
            this.group = this.type + (this.el.closest('[data-component-group]').data('component-group') || "");
            this.state = this.el.data('component-state');
            this.request = null;
            this.isCloning = false;

            this.controller = this.el.closest('[data-component-controller]').data('component-controller');

            this.siblings = pc ? pc.components[this.group] || [] : [];

            this.selectors = {
                editComponent: '> .card > .component-edit > [data-component-role="EditComponent"]',
                viewComponent: '> .card > .component-view > [data-component-role="ViewComponent"]',
                buttons: {
                    cancel: '> .card > .component-edit > .component-buttons [data-component-role="CancelButton"]',
                    clone: '> .card > .component-view > [data-component-role="CloneButton"]',
                    edit: '> .card > .component-view > .component-buttons > [data-component-role="EditButton"]',
                    remove: '> .card > .component-edit > .component-buttons [data-component-role="RemoveButton"]',
                    save: '> .card > .component-edit > .component-buttons [data-component-role="SaveButton"]'
                },
                validationToken: 'input[name="__RequestVerificationToken"]'
            };


            var controllerUrl = this.page.appPath + '/' + this.controller;

            this.urls = {
                view: controllerUrl + '/Show' + this.type,
                clone: controllerUrl + '/Show' + this.type + 'CloneForm',
                edit: controllerUrl + '/Show' + this.type + 'Form',
                save: controllerUrl + '/Update' + this.type,
                remove: controllerUrl + '/Remove' + this.type
            };

            this.components = {};
            this.componentActions = {};

            this.noResultsElement = (pc) ? pc.components[this.group + '-noResults'] || [] : [];
            this.viewComponent = '';
            this.editComponent = '';
        },
        PageAction: function (e, pc, page) {
            this.el = $(e);
            this.parentController = pc || {};
            this.page = page || app.page;
            this.action = this.el.closest('[data-component-action]').data('component-action');
            this.event = this.el.closest('[data-component-action-event]').data('component-action-event') || 'click';
            this.type = this.el.closest('[data-component-type]').data('component-type');
            this.target = this.el.closest('[data-component-action-target]').data('component-action-target');
            this.targetType = this.el.closest('[data-component-action-target-type]').data('component-action-target-type');
            this.subtype = this.el.closest('[data-component-subtype]').data('component-subtype');

            switch (this.action) {
                case "filter":
                    this.filterField = this.el.closest('[data-component-action-field]').data('component-action-field');
                    break;
                case "setvalue":
                    this.value = this.el.closest('[data-component-action-value]').data('component-action-value');
                    break;
            }
        }
    };

    //component events
    myComponent.Component.prototype.init = function () {
        if (this.siblings.length === 0 && this.noResultsElement !== undefined) {
            $(this.noResultsElement).slideUp();
        }

        if (this.state !== 'active') {
            this.startViewMode(true);
        } else {
            this.bindViewMode();
            this.finishLoad();
        }
    };
    myComponent.Component.prototype.finishLoad = function () {
        if (this.role === 'accordion') { /*f/b*/ window.Foundation.reInit($('.accordion')); }
        if (this.isEditing()) { this.startEditMode(); }
        this.page.log(this.type + ' component id ' + this.id + ' loaded.');
    };
    myComponent.Component.prototype.removeComponent = function () {
        var index = this.siblings.indexOf(this);
        if (this.siblings.length <= 1) {
            $(this.noResultsElement).slideDown();
        }

        this.siblings.splice(index, 1);
        if (this.role === 'accordion') {
            this.el.closest('li.accordion-item').remove();
        } else {
            this.el.remove();
        }
    };
    myComponent.Component.prototype.bindEditMode = function () {
        this.page.bindCheckboxLists(this.el);
        this.el.foundation();

        //handle enter keypress on a form
        $('form', this.el).on('keydown', $.proxy(function () {
            switch (event.keyCode) {
                case 13:
                    // Stop default form submission on "enter" click in textbox
                    if ($(event.target).is("input[type='text']")) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    break;
                case 27:
                    event.preventDefault();
                    event.stopPropagation();
                    //this.cancelEditMode();
                    break;
            }
        }, this));

        $(document).trigger("component-bind-edit-mode-complete", this);
        $(document).trigger("component-bind-edit-mode-complete-" + this.type, this);

        this.bindSubComponents();
    };
    myComponent.Component.prototype.bindViewMode = function () {
        this.editComponent = $(this.selectors.editComponent, this.el);
        this.viewComponent = $(this.selectors.viewComponent, this.el);

        $(this.selectors.buttons.edit, this.el).on('click', $.proxy(this.startEditMode, this));
        $(this.selectors.buttons.clone, this.el).on('click', $.proxy(this.startCloneMode, this));
        $(this.selectors.buttons.cancel, this.el).on('click', $.proxy(this.cancelEditMode, this));
        $(this.selectors.buttons.save, this.el).on('click', $.proxy(this.saveEditMode, this));
        $(this.selectors.buttons.remove, this.el).on('click', $.proxy(this.startRemove, this));

        this.el.foundation();

        $(document).trigger("component-bind-view-mode-complete", this);
        $(document).trigger("component-bind-view-mode-complete-" + this.type, this);

        this.bindSubComponents();
    };
    myComponent.Component.prototype.bindSubComponents = function () {
        var controller = this;

        this.components = {};
        $(this.page.selectors.components, this.el).not($(this.page.selectors.components + ' ' + this.page.selectors.components, this.el)).each(function () { controller.page.initComponent(this, controller); });
        $(this.page.selectors.componentActions, this.el).not($(this.page.selectors.components + ' ' + this.page.selectors.componentActions, this.el)).each(function () { controller.page.initPageAction(this, controller); });
    };
    myComponent.Component.prototype.startLoading = function () {
        this.el.addClass('component-loading');
        $(document).trigger("component-loading-start", this);
    };
    myComponent.Component.prototype.endLoading = function () {
        this.el.removeClass('component-loading');
        $(document).trigger("component-loading-complete", this);
    };
    myComponent.Component.prototype.startViewMode = function (isInit, filterCriteria) {
        this.startLoading();
        var data;

        if (filterCriteria) {
            data = filterCriteria;
        } else {
            data = { id: this.id, controllerId: this.parentController.id, subtype: this.subtype };
        }

        if (this.request != null) {
            this.request.abort();
            this.request = null;
        }

        this.request = $.ajax({ url: this.urls.view, data: data, context: this, error: this.page.handleAjaxError }).done(function (data) {
            this.el.html(data);
            this.endLoading();
            this.bindViewMode();
            if (isInit) {
                this.finishLoad();
            }
        });
    };
    myComponent.Component.prototype.startCloneMode = function () {
        this.isCloning = true;
        this.startEditMode();
    };
    myComponent.Component.prototype.startEditMode = function () {
        this.startLoading();

        $.ajax({ url: this.urls.edit, data: { id: this.id, controllerId: this.parentController.id, subtype: this.subtype }, context: this, error: this.page.handleAjaxError }).done(function (data) {
            this.editComponent.html(data);

            if (this.isCloning) {
                $('[name="Id"]', this.editComponent).val(0);
            }
            this.el.foundation();
            this.el.addClass('edit');
            this.endLoading();
            this.bindEditMode();
        });
    };
    myComponent.Component.prototype.cancelEditMode = function () {
        if (this.isCloning) { this.isCloning = false; }

        if (this.id === 0) {
            this.removeComponent();
        } else {
            this.el.removeClass('edit');
        }

        $(document).trigger("component-edit-cancel", this);
        $(document).trigger("component-edit-cancel-" + this.type, this);
    };
    myComponent.Component.prototype.saveEditMode = function () {
        var form = $('form:not(.component-exclude)', this.editComponent);
        $.validator.unobtrusive.parse(form);

        console.log(form.valid());
        if (form.valid()) {
            var componentTop = this.editComponent.offset().top - 50;
            //if the top of the component is off of the page, jump to it
            if ($(document).scrollTop() > componentTop)
                $('html, body').scrollTop(componentTop);
            this.startLoading();
            $.ajax({ url: this.urls.save, method: 'post', data: form.serialize(), context: this, error: this.page.handleAjaxError }).done(function (data) {
                this.endLoading();

                if (data) {
                    //check if result is json, if so we have an issue
                    if (this.page.isJsonString(data)) {
                        this.page.handleJsonMessage($.parseJSON(data));
                    } else {
                        //it worked, replace the current view partial.
                        this.viewComponent.html(data);
                        if (this.id === 0 || this.isCloning) {
                            this.id = parseInt($('[name="Id"]', this.viewComponent).val());
                            if (this.isCloning) { this.isCloning = false; }
                            //this.bindViewMode();
                        }

                        this.bindSubComponents();
                        $(document).trigger("component-save-complete", this);
                        $(document).trigger("component-save-complete-" + this.type, this);
                        this.cancelEditMode();
                    }
                } else {
                    $(app.page.selectors.modals.saveError).foundation('open');
                }
            });
        }
        else {
            //Give focus to the first error
            var firstError = $('#' + $('.field-validation-error', form).data('valmsg-for'));
            if (firstError.length) {
                $('html, body').animate({
                    scrollTop: firstError.offset().top - 50
                }, 500);
            }
        }
    };
    myComponent.Component.prototype.startRemove = function () {
        if (this.id === 0) {
            this.removeComponent();
        } else {
            if (this.urls.remove !== undefined && this.urls.remove !== '') {
                app.page.currentComponent = this;
                $(app.page.selectors.modals.removeConfirm).foundation('open');
            }
        }
    };
    myComponent.Component.prototype.confirmRemove = function () {
        if (this.urls.remove !== undefined && this.urls.remove !== '') {
            this.el.removeClass('edit');
            this.startLoading();

            $.ajax({ url: this.urls.remove, method: 'post', data: { id: this.id, controllerId: this.parentController.id, __RequestVerificationToken: $(this.selectors.validationToken, this.editComponent).val() }, context: this, error: this.page.handleAjaxError }).done(function (data) {
                if (data) {
                    if (this.page.isJsonString(data)) {
                        if (this.page.handleJsonMessage($.parseJSON(data))) {
                            this.el.addClass('edit');
                            this.endLoading();
                        } else {
                            this.removeComponent();
                            $(document).trigger("component-remove-complete", this);
                            $(document).trigger("component-remove-complete-" + this.type, this);
                        }
                    }
                } else {
                    this.el.addClass('edit');
                    this.endLoading();
                    $('#saveErrorModal').foundation('open');
                }
            });
        }
    };

    //component derived properties
    myComponent.Component.prototype.isEditing = function () {
        return this.el.hasClass('edit');
    };
    myComponent.PageAction.prototype.triggerAction = function (e) {
        this.page.log('component action ' + this.action + ' for ' + this.target + ' triggered.');

        switch (this.action) {
            case "add":
                this.pageComponentActionAdd(this.el, this.parentController, this.target);
                break;
            case "filter":
                this.pageComponentActionFilter(this.el, this.target);
                break;
            case "filterserver":
                this.pageComponentActionFilterServer(this.el, this.target, e);
                break;
            case "refresh":
                this.pageComponentActionRefresh(this.el, this.target);
                break;
            case "setoptions":
                this.pageComponentActionUpdateSetOptions(this.el, this.target);
                break;
            case "setvalue":
                this.pageComponentActionUpdateSetValue(this.el, this.target);
                break;
            case "setvisibility":
                this.pageComponentActionUpdateSetVisibility(this.el, this.target);
                break;
            case "updateid":
                this.pageComponentActionUpdateId(this.el, this.target);
                break;
            case "updatesubtype":
                this.pageComponentActionUpdateSubtype(this.el, this.target);
                break;
        }

        this.postAction();
    };
    myComponent.PageAction.prototype.postAction = function () { };
    myComponent.PageAction.prototype.pageComponentActionAdd = function (el, pc, t) {
        var target = $('[data-role~="component-action-target"][data-component-target="' + t + '"]', pc.el);
        var componentWrapper;

        if (el.data('component-template') && $('[data-role~="component-template"][data-template-name="' + el.data('component-template') + '"]')) {
            componentWrapper = $('[data-role~="component-template"][data-template-name="' + el.data('component-template') + '"]').html();
        } else {
            var wrapperType = el.data('component-wrapper-type') ? el.data('component-wrapper-type') : 'div';
            componentWrapper = '<' + wrapperType + ' class="edit ' + (el.data('component-wrapper-class') ? el.data('component-wrapper-class') : "") + '" data-role="component" data-component-id="0"></' + wrapperType + '>';
        }

        if (el.data('parent-id')) {
            pc.id = el.data('parent-id');
        }
        var newComponentSelector;
        switch (target.data('component-insert-type')) {
            case 'append':
                target.append(componentWrapper);
                newComponentSelector = $('[data-role~="component"]:last', target);
                break;
            case 'sibling-append':
                target.after(componentWrapper);
                newComponentSelector = target.next();
                break;
            case 'sibling-prepend':
                target.before(componentWrapper);
                newComponentSelector = target.prev();
                break;
            default:
                target.prepend(componentWrapper);
                newComponentSelector = $('[data-role~="component"]:first', target);
                break;
        }

        this.subtype = this.el.closest('[data-component-subtype]').data('component-subtype');

        this.page.initComponent(newComponentSelector, pc, this.subtype);
        $(document).trigger("component-add-complete", newComponentSelector);
        $(componentWrapper).foundation();
    };
    myComponent.PageAction.prototype.pageComponentActionFilter = function (el, t) {

        var context = $('[data-role~="component-action-target"][data-component-target~="' + this.target + '"]');
        var rows = $('[data-role~="component"]', context);
        var form = $('form[data-role="filter-server-form"][data-component-action-target-type~="' + this.targetType + '"]');
        rows.show();

        $(':input', form).each(function (i, e) {
            var el = $(e);
            if (el.val() !== '') {
                var field;

                if (el.data('target')) {
                    field = '[data-label="' + el.data('target') + '"]';
                }
                else {
                    field = '[data-label]';
                }

                var values = el.val().toUpperCase().split(/\s+/);
                rows.each(function (i, e) {
                    var hide = false;

                    $.each(values, function (index, v) {
                        if ($(field + ':icontains("' + v + '")', e).length < 1) {
                            hide = true;
                            return;
                        }
                    });
                    if (hide) {
                        $(e).hide();
                    }
                });
            }
        });

    };
    myComponent.PageAction.prototype.pageComponentActionFilterServer = function (el, t,e) {

        if (e === undefined || e.type !== "keyup" || app.page.isPrintableCharacter(e.keyCode)) {
            //if keyup, add a delay
            var delay = 300;
            if (e !== undefined && e.type !== "keyup") {
                delay = 0;
            }

            if (this.timeout !== null) { clearTimeout(this.timeout); }
            var that = this;
            this.timeout = setTimeout(function () {

                var form = $('form[data-role="filter-server-form"][data-component-action-target-type="' + that.targetType + '"]');

                var dataRoles = el.data('role');
                if (dataRoles.indexOf('page-size') !== -1) {

                    //append to form
                    if (form.find('[name="pageSize"]').length) {
                        form.find('[name="pageSize"]').val(el.val());
                    } else {
                        //add to form
                        $('<input>').attr({
                            type: 'hidden',
                            id: 'pageSize',
                            name: 'pageSize',
                            value: el.val()
                        }).appendTo(form);
                    }
                }

                var filters = form.serializeArray();

                if (el.data('pageValue')) {
                    filters.push({ name: "pageNumber", value: el.data('pageValue') });
                }

                var target = that.page.components[that.targetType][0];
                target.startViewMode(false, $.param(filters));

            }, delay,el, that);
        }
    };
    myComponent.PageAction.prototype.pageComponentActionRefresh = function (el, t) {
        var target = this.page.components[t][0];
        if (target) {
            target.startViewMode();
        }
    };
    myComponent.PageAction.prototype.pageComponentActionUpdateId = function (el, t) {
        var target = this.page.components[t][0];
        var val;
        if (el.data('component-action-updateid-value')) {
            val = el.data('component-action-updateid-value');
        } else {
            val = el.val();
        }
        if (val.length > 0) {
            target.id = val;
            target.startViewMode();
        }
    };
    myComponent.PageAction.prototype.pageComponentActionUpdateSubtype = function (el, t) {
        var target = $('[data-role~="component-action-target"][data-component-target="' + t + '"]');
        target.data('component-subtype', el.val());
    };
    myComponent.PageAction.prototype.pageComponentActionUpdateSetOptions = function (el, t, e) {
        var targets = $('[data-component-target="' + t + '"]');
        var values = $('input:checked', el);
        targets.each(function (i, e) {
            var targetField = $(e).data('component-action-setoptions-field');
            
            switch ($(e).data('component-action-setoptions-type')) {
                case "showequal":
                    //remove all options
                    if (values.length === 0 || values[0].value === '0') {
                        $('.select-many-checkbox', e).show();
                    } else {
                        $('.select-many-checkbox', e).hide();
                        $('.select-many-checkbox', e).prop('checked', false).trigger("change");

                        values.each(function (i2, e2) {
                            var value = $(e2).val();
                            //re add for thisv value
                            $('.select-many-checkbox', e).each(function () {
                                if ($('input', this).attr(targetField) === value) {
                                    $(this).show();
                                }
                            });
                        });
                    }
                    break;
            }
        });
    };
    myComponent.PageAction.prototype.pageComponentActionUpdateSetValue = function (el, t) {
        var target = $(t);
        target.val($(el).data("component-action-value"));
    };
    myComponent.PageAction.prototype.pageComponentActionUpdateSetVisibility = function(el, t) {
        var targets = $('[data-component-target="' + t + '"]');
        var val = el.val();
        targets.each(function(i, e) {
            switch($(e).data('component-action-setvisibility-type')) {
                case "showequal":
                    if (val === $(e).data('component-action-setvisibility-value').toString()) {
                        $(e).slideDown();
                    } else {
                        $(e).slideUp();
                    }
                    break;
            }
        });
    };

    return myComponent;
}());

$(function () {
    app.page = new app.Page(window.applicationPath);
    $(document).trigger('page-init-complete');
});